<form class="d-flex flex-row min-width">
  <now-wbsuche-lib-typeahead
    id="Suche-Ort"
    #ortTypeahead
    label="{{ messages.UMKREIS_SUCHEINGABE_LABEL }}"
    iconClass="now-icon now-icon-map-pin"
    placeholder="{{ messages.ORT_EINGABEFELD_INFO }}"
    [loadSuggestions]="loadSuggestions"
    (suggestionSelected)="onSuggestionSelected($event)"
    maxlength="60"
    class="flex-grow-1"
    [initialSearchInput]="(ortLabel$ | async)!"
    [resetOnSubmit]="false"
  >
  </now-wbsuche-lib-typeahead>
  <div class="position-relative">
    @if (isEmpty(ortTypeahead.inputContent$)) {
      <button
        (click)="locationFromBrowser($event)"
        [ngClass]="{ loading: ladeGeolocation, 'now-icon now-icon-crosshair': !ladeGeolocation }"
        class="now-btn now-btn-icon-only d-print-none position-absolute"
        aria-label="Eigenen Standort bestimmen"
        id="locate-btn"
        data-bs-toggle="popover"
        data-bs-placement="top"
        data-bs-content="Eigenen Standort bestimmen"
      ></button>
    }
  </div>
</form>
@if (geolocationPositionError) {
  <p class="form-text">Standort konnte nicht ermittelt werden. Bitte Ort oder PLZ eingeben.</p>
}
